import { SVGProps } from "react";

const GoogleIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12.2441 21.7792C12.9846 22.7053 13.7388 23.8697 14.1334 24.5731C14.6141 25.4875 14.8133 26.1048 15.1709 27.2107C15.3799 27.8163 15.5792 28 15.9973 28C16.4545 28 16.6635 27.6913 16.8238 27.2107C17.1579 26.1732 17.4157 25.3839 17.8241 24.6317C19.3988 21.662 21.9661 19.5519 23.4118 16.6604C23.4118 16.6604 24.3633 14.8942 24.3633 12.4207C24.3633 10.1153 23.4255 8.51318 23.4255 8.51318L12.25 21.7988L12.2441 21.7792Z"
				fill="#34A853"
			/>
			<path
				d="M8.45313 16.3478C9.35381 18.3992 11.0712 20.1967 12.2434 21.7792L18.4564 14.4136C18.4564 14.4136 17.5791 15.5624 15.9946 15.5624C14.2284 15.5624 12.7905 14.1557 12.7905 12.3777C12.7905 11.1547 13.5192 10.3068 13.5192 10.3068C8.94743 10.9867 9.20142 12.0945 8.43945 16.3439L8.45313 16.3478Z"
				fill="#FBBC04"
			/>
			<path
				d="M18.5348 4.38489C20.6058 5.05112 22.3642 6.45587 23.4192 8.50732L18.4567 14.4272C18.4567 14.4272 19.1854 13.5754 19.1854 12.3562C19.1854 10.5412 17.6537 9.1716 16.0008 9.1716C14.4319 9.1716 13.5391 10.3067 13.5391 10.3067C13.92 9.43927 17.8569 4.67991 18.5407 4.38684L18.5348 4.38489Z"
				fill="#4285F4"
			/>
			<path
				d="M9.58594 6.98925C10.8207 5.52003 12.9855 4 15.9747 4C17.4186 4 18.5146 4.38294 18.5146 4.38294L13.5325 10.3028C13.1965 10.1205 9.91808 7.56757 9.58594 6.98144V6.98925Z"
				fill="#1A73E8"
			/>
			<path
				d="M8.45339 16.3478C8.45339 16.3478 7.63867 14.7301 7.63867 12.4012C7.63867 10.1934 8.50223 8.2592 9.59243 7.00879L13.539 10.3302L8.45925 16.3478H8.45339Z"
				fill="#EA4335"
			/>
		</svg>
	);
};

export default GoogleIcon;
